import React from 'react';
import autosize from 'autosize';

import ErrorMessage from 'components/vistaprintUILibrary/ErrorMessage';
import { colors } from 'settings/theme';

// this needs to be a class because the autosize functionality depends on a ref and stateless components cannot have refs
export default class TextArea extends React.Component {
    constructor(props) {
        super(props);

        this.textareaRef = React.createRef();

        this.state = {
            placeholderShown: true,
        };

        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    onFocus(event) {
        this.setState({
            placeholderShown: false,
        });

        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
    }

    onBlur(event) {
        const {
            value,
            onBlur,
        } = this.props;

        if (!value || value.length === 0) {
            this.setState({
                placeholderShown: true,
            });
        }

        if (onBlur) {
            onBlur(event);
        }
    }

    render() {
        const {
            value, // required
            onChange, // required
            placeholder = undefined,
            autoResize = false,
            rows = 4,
            label = undefined,
            fullWidth = false,
            id = undefined, // required if label is provided (to link label and input)
            errorMessage = null,
            required = false,
            disabled = false,
            containerStyle = {},
            labelStyle = {},
            style = {},
            ...restProps, // additional props will be added to the textarea element
        } = this.props;

        const {
            placeholderShown,
        } = this.state;

        if (label && !id) {
            throw new Error('"id" property is required if "label" is provided. "id" is needed to link the label and input elements');
        }

        // ui library doesn't seem to have a class to add for errors on a textarea (the input-skin-error class only works on input elements)
        let errorStyle = {};
        if (errorMessage !== null) {
            errorStyle = {
                borderColor: colors.danger,
                boxShadow: `inset 0 0 0 1px ${colors.danger}`,
            };
        }

        return (
            <div
                style={containerStyle}
            >
                {label &&
                    <label
                        className="above"
                        htmlFor={id}
                        style={labelStyle}
                    >
                        {`${label}${required ? '*' : ''}`}
                    </label>
                }
                <textarea
                    id={id}
                    ref={this.textareaRef}
                    type="text"
                    className="stylized-textarea"
                    disabled={disabled}
                    value={value}
                    placeholder={placeholderShown ? placeholder : ''}
                    rows={rows}
                    onChange={(event) => {
                        if (autoResize) {
                            autosize(this.textareaRef.current);
                        }
                
                        onChange(event);
                    }}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    style={{
                        width: fullWidth ? '100%' : undefined,
                        ...style,
                        ...errorStyle,
                    }}
                    {...restProps}
                />
                <ErrorMessage containerStyle={{ marginTop: 3 }} text={errorMessage} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/TextArea.js